import {
  EDIT_SERVICE_PATH,
  EDIT_EMPLOYEE_PATH,
  EDIT_SALES_FUNNEL_PATH,
  VIEW_SENDOUTS_PATH,
} from '@app/constants';

export const PATHS_WITH_EXTRA_PAGE_TITLE = [
  '/clients/edit/',
  '/clients/card/',
  EDIT_EMPLOYEE_PATH,
  '/users/edit/',
  EDIT_SALES_FUNNEL_PATH,
  VIEW_SENDOUTS_PATH,
  EDIT_SERVICE_PATH,
];
